import { render, staticRenderFns } from "./EntryMultiTab.vue?vue&type=template&id=63fdf5fb&scoped=true&"
import script from "./EntryMultiTab.vue?vue&type=script&lang=js&"
export * from "./EntryMultiTab.vue?vue&type=script&lang=js&"
import style0 from "./EntryMultiTab.vue?vue&type=style&index=0&id=63fdf5fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fdf5fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63fdf5fb')) {
      api.createRecord('63fdf5fb', component.options)
    } else {
      api.reload('63fdf5fb', component.options)
    }
    module.hot.accept("./EntryMultiTab.vue?vue&type=template&id=63fdf5fb&scoped=true&", function () {
      api.rerender('63fdf5fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EntryLayout/EntryMultiTab.vue"
export default component.exports